<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/134/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                      alt=""
                  />
                  <div class="content">
                    为贯彻落实《成都市创建吸引和集聚人才平台激发人才创新创造活力的若干政策措施》（成委厅〔2022〕41号），激发人才创新创造活力，从2023年起，市级层面每年从返乡入乡创办领办农民专业合作社和家庭农场的高校毕业生、退役军人、农民工中，遴选支持100名优秀人才给予资助，鼓励支持更多人才运用自身知识才能，投身现代都市农业，发展适度规模经营，提升生产经营水平，促进农业产业发展和农民增收。
                  </div>
              </div>
              <div class="zccl" >
                  <img
                      class="top"
                      src="./../assets/imgs/134/title1.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    17个涉农区（市）县农业农村部门会同对应的首席专家，筛选在蓉涉农科研院校所专家、市县农技推广人才、乡村“土专家”“田秀才”、新型农业经营主体等各类人才，分别组建1个农业科技专家服务团，面向区（市）县域范围内的涉农企业、农民专业合作社、家庭农场、种植（养殖）大户以及涉农协会等，深入农业园区、示范基地以及田间地头，开展农业决策咨询、技术指导、创新攻关、试验示范、推广应用、观摩培训、农资推介、病虫害诊断、品牌创建、人才培育、政策宣传等服务。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/134/title2.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （一）申报对象个人基本条件
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            1. 拥护中国共产党领导，有良好的职业道德和敬业精神，扎根农业农村一线，热爱“三农”工作。 <br>
                            2. 申报人年龄在18周岁以上。 <br>
                            3. 高校毕业生应提供毕业证书，退役军人应提供军人退出现役证明，农民工应提供相关证明（本市集体经济组织成员证明，在外务工6个月及以上工资发放、社保缴纳证明等）。
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （二）申报对象创办领办主体基本条件
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            1. 在市场监管部门注册登记不超过3年，且已纳入农业农村主管部门经营主体名录库管理。 <br>
                            2. 依法规范经营，有固定办公场所和基本办公设施设备，营业执照、标识标牌、章程制度完善，生产档案、记录管理规范，实行分类整理、集中管理、专人负责。 <br>
                            3. 印章齐全，有独立的银行账户，财务管理规范。配备会计人员或将财务进行委托代理；农民专业合作社执行财政部《农民专业合作社会计制度》（财会〔2021〕37号）。 <br>
                            4. 经营状况良好。农民专业合作社服务能力较强，联农助农作用明显；家庭农场发展规模适度、集约化经营水平较高。
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （三）优先条件
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            <span style="font-weight: bold;">申报对象除具备上述基本条件外，还具备以下条件的予以优先： </span><br>
                            1. 主要从事粮食和大豆油料生产经营。 <br>
                            2. 开展农业生产社会化服务。 <br>
                            3. 积极参加高素质农民、农业职业经理人等各类学习培训，提升自身能力水平，获得了相关认定或证书。 <br>
                            4. 与大专院校、科研院所开展联合合作，打造农业科研实验基地，积极试验、示范、推广应用新技术，在作物栽培、病虫害防治、动物疫病诊治、新品种培育推广、改良、农产品加工等方面有独特技艺，具备丰富的生产实践经验和技术优势，获得一定范围内的社会认可。 <br>
                            5. 受到过各级政府和有关部门表彰，创办领办的农民专业合作社、家庭农场获评市级以上示范等级，入选了典型案例，产品获得国际国内相关奖励荣誉。 <br>
                            6. 在生态农业、数字农业、智慧农业、创意休闲农业、农机农艺融合、烘干冷链物流、农村电子商务、乡村旅游等农业农村领域具有较高经营水平，带动农民增收成效明显，获得一定范围内的社会认可。
                          </div>
                      </div>
                  </div>
              </div>

              <div class="gmlc">
                  <img
                      class="top"
                      src="./../assets/imgs/134/title3.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des mar-t3">
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">1</div>
                                  <div class="line-title">下发通知</div>
                              </div>
                              <div class="line-content">
                                市农业农村局制发通知，启动上一年度返乡入乡创办领办农民专业合作社和家庭农场优秀人才评选工作，各区（市）县农业农村部门按照通知要求组织开展申报工作。
                              </div>
                          </div>
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">2</div>
                                  <div class="line-title">个人申报</div>
                              </div>
                              <div class="line-content">
                                申报人对照申报条件，根据通知要求准备相关申报材料，向所在镇（街）提出书面申请，并提交相关申报材料。
                              </div>
                          </div>

                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line" style="height: 140%;"></div>
                                  <div class="line-num">3</div>
                                  <div class="line-title" style="text-wrap: nowrap;">审核推荐</div>
                              </div>
                              <div class="line-content">
                                所在镇（街道）对申报人申报材料进行初审，区（市）县农业农村部门对申报人选和申报材料的真实性、准确性进一步审核把关，实地查看主体经营情况，按照相关规定进行公示后，报送市农业农村局。
                              </div>
                          </div>

                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line" style="height: 140%;"></div>
                                  <div class="line-num">4</div>
                                  <div class="line-title" style="text-wrap: nowrap;">评审公示</div>
                              </div>
                              <div class="line-content">
                                市农业农村局负责对申报材料进行复核，并组织专家进行评审，经局党组会议研究后，按照择优原则确定获选人员名单。按照相关规定进行公示后，发布确认通知。
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="zccl" style="margin-top: 0.8rem;">
                  <img
                      class="top"
                      src="./../assets/imgs/134/title4.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    对经过相关程序评选，获得返乡入乡创办领办农民专业合作社、家庭农场优秀人才荣誉的高校毕业生、退役军人、农民工给予每人3万元资助。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/134/title5.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;font-weight: bolder;">
                    按相关通知要求进行。
                  </div>
              </div>
              <div class="contact" style="margin-top: 0.3rem">
                  <img
                      class="top"
                      src="./../assets/imgs/134/title6.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-61883548">028-61883548</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          成都市农业农村局
                      </div>
                  </div>
              </div>
              <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/134/code.png" />
              </div> -->
          </div>
      </section>
      <call phone="028-61883548"></call>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
      width: 7.26rem;
      height: 5.6rem;
  }

  .technological-process {
      transform: translateY(-2.6rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 1.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.3rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.35rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 0.6em;
                }
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 4.86rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.5rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.62rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 1.1em;
                }
              }

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
